"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
exports.__esModule = true;
exports.bakeCorjArray = exports.makeCaughtObjectReportJsonArray = exports.bakeCorj = exports.makeCaughtObjectReportJson = exports.CorjMaker = exports.CORJ_MAKER_DEFAULT_OPTIONS = exports.CORJ_REPORT_ARRAY_JSON_SCHEMA_LINK = exports.CORJ_REPORT_OBJECT_JSON_SCHEMA_LINK = exports.CORJ_VERSION = exports.CORJ_AS_STRING_FORMAT_TO_CORJ_AS_STRING_METHOD = exports.CORJ_AS_STRING_FORMAT_STRING_COERCION = exports.CORJ_AS_JSON_FORMAT_TO_CORJ_AS_JSON_METHOD = exports.CORJ_AS_JSON_FORMAT_SAFE_STABLE_STRINGIFY_2_4_1 = exports.CORJ_NESTED_OMITTED_REASONS = void 0;
var safe_stable_stringify_1 = require("safe-stable-stringify");
//  ██████╗ ██████╗ ███╗   ██╗███████╗████████╗ █████╗ ███╗   ██╗████████╗███████╗
// ██╔════╝██╔═══██╗████╗  ██║██╔════╝╚══██╔══╝██╔══██╗████╗  ██║╚══██╔══╝██╔════╝
// ██║     ██║   ██║██╔██╗ ██║███████╗   ██║   ███████║██╔██╗ ██║   ██║   ███████╗
// ██║     ██║   ██║██║╚██╗██║╚════██║   ██║   ██╔══██║██║╚██╗██║   ██║   ╚════██║
// ╚██████╗╚██████╔╝██║ ╚████║███████║   ██║   ██║  ██║██║ ╚████║   ██║   ███████║
// ╚═════╝ ╚═════╝ ╚═╝  ╚═══╝╚══════╝   ╚═╝   ╚═╝  ╚═╝╚═╝  ╚═══╝   ╚═╝   ╚══════╝
exports.CORJ_NESTED_OMITTED_REASONS = {
    REACHED_MAX_DEPTH: function (maxDepth) { return "Reached max depth - ".concat(maxDepth); }
};
exports.CORJ_AS_JSON_FORMAT_SAFE_STABLE_STRINGIFY_2_4_1 = 'safe-stable-stringify@2.4.1';
exports.CORJ_AS_JSON_FORMAT_TO_CORJ_AS_JSON_METHOD = '.toCorjAsJson';
exports.CORJ_AS_STRING_FORMAT_STRING_COERCION = 'String';
exports.CORJ_AS_STRING_FORMAT_TO_CORJ_AS_STRING_METHOD = '.toCorjAsString';
exports.CORJ_VERSION = 'corj/v0.8';
exports.CORJ_REPORT_OBJECT_JSON_SCHEMA_LINK = "https://raw.githubusercontent.com/dany-fedorov/caught-object-report-json/main/schema-versions/".concat(exports.CORJ_VERSION, "/report-object.json");
exports.CORJ_REPORT_ARRAY_JSON_SCHEMA_LINK = "https://raw.githubusercontent.com/dany-fedorov/caught-object-report-json/main/schema-versions/".concat(exports.CORJ_VERSION, "/report-array.json");
exports.CORJ_MAKER_DEFAULT_OPTIONS = Object.freeze({
    metadataFields: {
        $schema: false,
        as_json_format: true,
        children_sources: true,
        as_string_format: true,
        v: true
    },
    childrenMetadataFields: {
        $schema: false,
        as_json_format: false,
        children_sources: false,
        as_string_format: false,
        v: false
    },
    asJsonFormatsToApply: ['.toCorjAsJson', 'safe-stable-stringify@2.4.1'],
    asStringFormatsToApply: ['.toCorjAsString', 'String'],
    maxChildrenLevel: 5,
    childrenSources: ['cause', 'errors'],
    makeReportId: function (_a) {
        var index = _a.index;
        return (index === -1 ? 'root' : String(index));
    },
    onCaughtMaking: function (caught, _a) {
        var reason = _a.reason, propAccessHostName = _a.propAccessHostName, propAccessPropName = _a.propAccessPropName, caughtWhenProcessingReportKey = _a.caughtWhenProcessingReportKey, caughtObjectNestingInfo = _a.caughtObjectNestingInfo;
        var message = [
            "Reason - ".concat(reason),
            "Caught Object - ".concat(caught),
            reason !== 'prop-access' || typeof propAccessHostName !== 'string'
                ? null
                : "Prop Host - ".concat(propAccessHostName),
            reason !== 'prop-access' || typeof propAccessPropName !== 'string'
                ? null
                : "Prop Name - ".concat(propAccessPropName),
            !caughtWhenProcessingReportKey
                ? null
                : "Caught when processing Report Key - ".concat(caughtWhenProcessingReportKey),
            !caughtObjectNestingInfo
                ? 'Level - Caught processing toplevel caught object'
                : "Level - Caught processing nested caught object ".concat(jsonStringify(caughtObjectNestingInfo)),
        ]
            .filter(Boolean)
            .map(function (l) { return "[caught-object-report-json] [Default Error Handler] ".concat(l); })
            .join('\n');
        console.warn(message);
    },
    printWarningsOnUnhandledErrors: true
});
// ██╗  ██╗███████╗██╗     ██████╗ ███████╗██████╗ ███████╗
// ██║  ██║██╔════╝██║     ██╔══██╗██╔════╝██╔══██╗██╔════╝
// ███████║█████╗  ██║     ██████╔╝█████╗  ██████╔╝███████╗
// ██╔══██║██╔══╝  ██║     ██╔═══╝ ██╔══╝  ██╔══██╗╚════██║
// ██║  ██║███████╗███████╗██║     ███████╗██║  ██║███████║
// ╚═╝  ╚═╝╚══════╝╚══════╝╚═╝     ╚══════╝╚═╝  ╚═╝╚══════╝
var jsonStringify = (0, safe_stable_stringify_1.configure)({
    circularValue: '[caught-object-report-json: Circular]',
    deterministic: false
});
function handleCaught(caughtNew, options, context) {
    if (typeof options.onCaughtMaking === 'function') {
        try {
            options.onCaughtMaking(caughtNew, context);
        }
        catch (caughtNew2) {
            if (options.printWarningsOnUnhandledErrors) {
                console.warn('[caught-object-report-json] `onCaughtMaking` callback threw!');
            }
        }
    }
    else {
        if (options.printWarningsOnUnhandledErrors) {
            console.warn('[caught-object-report-json] Muffling error because `onCaughtMaking` is not set.');
        }
    }
}
function screenOptionsForAccessorErrors(options) {
    var _a, _b, _c;
    if (options === exports.CORJ_MAKER_DEFAULT_OPTIONS) {
        return options;
    }
    try {
        options.metadataFields;
        if (typeof options.metadataFields === 'object') {
            options.metadataFields.as_json_format;
            options.metadataFields.as_string_format;
            options.metadataFields.v;
            options.metadataFields.$schema;
        }
        options.childrenMetadataFields;
        if (typeof options.childrenMetadataFields === 'object') {
            options.childrenMetadataFields.as_json_format;
            options.childrenMetadataFields.as_string_format;
            options.childrenMetadataFields.v;
            options.childrenMetadataFields.$schema;
        }
        options.asJsonFormatsToApply;
        (_a = options.asJsonFormatsToApply) === null || _a === void 0 ? void 0 : _a.forEach(function (f) { return f; });
        options.asStringFormatsToApply;
        (_b = options.asStringFormatsToApply) === null || _b === void 0 ? void 0 : _b.forEach(function (f) { return f; });
        options.makeReportId;
        options.printWarningsOnUnhandledErrors;
        options.onCaughtMaking;
        options.maxChildrenLevel;
        options.childrenSources;
        (_c = options.childrenSources) === null || _c === void 0 ? void 0 : _c.forEach(function (s) { return s; });
        return options;
    }
    catch (caught) {
        console.warn('[caught-object-report-json] Accessing one of properties on options object threw an error, falling back to default options');
        return exports.CORJ_MAKER_DEFAULT_OPTIONS;
    }
}
function safeAccessProp(caughtObjectNestingInfo, reportKey, options, hostName, host, propName) {
    var caughtDuring = false;
    if (host === undefined || host === null) {
        return { caughtDuring: caughtDuring };
    }
    try {
        if (['number', 'string', 'symbol', 'bigint', 'boolean'].includes(typeof host)) {
            var value = host[propName];
            if (value === undefined) {
                return { caughtDuring: caughtDuring };
            }
            return { value: value, caughtDuring: caughtDuring };
        }
        else {
            if (propName in host) {
                return { value: host[propName], caughtDuring: caughtDuring };
            }
            else {
                return { caughtDuring: caughtDuring };
            }
        }
    }
    catch (caughtNew) {
        caughtDuring = true;
        handleCaught(caughtNew, options, {
            propAccessPropName: propName,
            propAccessHostName: hostName,
            caughtObjectNestingInfo: caughtObjectNestingInfo,
            reason: 'prop-access',
            caughtWhenProcessingReportKey: reportKey
        });
    }
    return { caughtDuring: caughtDuring };
}
function getNestedObjectsOfCaught(caught, maker) {
    if (!caught ||
        typeof caught !== 'object' ||
        !('errors' in caught || 'cause' in caught)) {
        return [];
    }
    var nestedObjects = [];
    var _loop_1 = function (childrenSourceProp) {
        if (!(childrenSourceProp in caught)) {
            return "continue";
        }
        var source = caught[childrenSourceProp];
        var sourceArray = Array.isArray(source)
            ? source.map(function (s, i) { return ({
                obj: s,
                path: ".".concat(childrenSourceProp, "[").concat(i, "]")
            }); })
            : [{ obj: source, path: ".".concat(childrenSourceProp) }];
        nestedObjects.push.apply(nestedObjects, sourceArray);
    };
    for (var _i = 0, _a = maker.options.childrenSources; _i < _a.length; _i++) {
        var childrenSourceProp = _a[_i];
        _loop_1(childrenSourceProp);
    }
    return nestedObjects;
}
function makeMetadataValue(nestedCfg, options, propName, value) {
    var metadataConfig = nestedCfg === null
        ? options.metadataFields
        : options.childrenMetadataFields;
    if (metadataConfig === true ||
        (typeof metadataConfig === 'object' && metadataConfig[propName] === true)) {
        return { value: value };
    }
    return {};
}
function mergeOptions(baseOptions, newOptions) {
    var _a, _b;
    var effectiveOptions = newOptions === baseOptions
        ? newOptions
        : __assign(__assign(__assign({}, baseOptions), (newOptions !== null && newOptions !== void 0 ? newOptions : {})), { metadataFields: typeof (newOptions === null || newOptions === void 0 ? void 0 : newOptions.metadataFields) === 'boolean'
                ? newOptions.metadataFields
                : __assign(__assign(__assign({}, exports.CORJ_MAKER_DEFAULT_OPTIONS.metadataFields), (typeof baseOptions.metadataFields === 'boolean'
                    ? {}
                    : baseOptions.metadataFields)), ((_a = newOptions === null || newOptions === void 0 ? void 0 : newOptions.metadataFields) !== null && _a !== void 0 ? _a : {})), childrenMetadataFields: typeof (newOptions === null || newOptions === void 0 ? void 0 : newOptions.childrenMetadataFields) === 'boolean'
                ? newOptions.childrenMetadataFields
                : __assign(__assign(__assign({}, exports.CORJ_MAKER_DEFAULT_OPTIONS.childrenMetadataFields), (typeof baseOptions.childrenMetadataFields === 'boolean'
                    ? {}
                    : baseOptions.childrenMetadataFields)), ((_b = newOptions === null || newOptions === void 0 ? void 0 : newOptions.childrenMetadataFields) !== null && _b !== void 0 ? _b : {})) });
    return effectiveOptions;
}
// ██████╗ ███████╗██████╗  ██████╗ ██████╗ ████████╗    ██████╗ ██████╗  ██████╗ ██████╗ ███████╗    ██████╗ ██╗   ██╗██╗██╗     ██████╗ ███████╗██████╗ ███████╗
// ██╔══██╗██╔════╝██╔══██╗██╔═══██╗██╔══██╗╚══██╔══╝    ██╔══██╗██╔══██╗██╔═══██╗██╔══██╗██╔════╝    ██╔══██╗██║   ██║██║██║     ██╔══██╗██╔════╝██╔══██╗██╔════╝
// ██████╔╝█████╗  ██████╔╝██║   ██║██████╔╝   ██║       ██████╔╝██████╔╝██║   ██║██████╔╝███████╗    ██████╔╝██║   ██║██║██║     ██║  ██║█████╗  ██████╔╝███████╗
// ██╔══██╗██╔══╝  ██╔═══╝ ██║   ██║██╔══██╗   ██║       ██╔═══╝ ██╔══██╗██║   ██║██╔═══╝ ╚════██║    ██╔══██╗██║   ██║██║██║     ██║  ██║██╔══╝  ██╔══██╗╚════██║
// ██║  ██║███████╗██║     ╚██████╔╝██║  ██║   ██║       ██║     ██║  ██║╚██████╔╝██║     ███████║    ██████╔╝╚██████╔╝██║███████╗██████╔╝███████╗██║  ██║███████║
// ╚═╝  ╚═╝╚══════╝╚═╝      ╚═════╝ ╚═╝  ╚═╝   ╚═╝       ╚═╝     ╚═╝  ╚═╝ ╚═════╝ ╚═╝     ╚══════╝    ╚═════╝  ╚═════╝ ╚═╝╚══════╝╚═════╝ ╚══════╝╚═╝  ╚═╝╚══════╝
function makeProp_as_string(caught, options, nestedCfg) {
    var formats = options.asStringFormatsToApply;
    for (var i = 0; i < formats.length; ++i) {
        var format = formats[i];
        try {
            switch (format) {
                case exports.CORJ_AS_STRING_FORMAT_STRING_COERCION:
                    return {
                        format: format,
                        value: String(caught)
                    };
                case exports.CORJ_AS_STRING_FORMAT_TO_CORJ_AS_STRING_METHOD: {
                    var r = safeAccessProp(nestedCfg, 'as_string', options, 'caught', caught, 'toCorjAsString');
                    if (!('value' in r) || typeof r.value !== 'function') {
                        if (i < formats.length - 1) {
                            continue;
                        }
                        else {
                            return {
                                format: format,
                                value: null
                            };
                        }
                    }
                    else {
                        var value = r.value.call(caught, { options: options, caught: caught, nestedCfg: nestedCfg });
                        if (typeof value !== 'string') {
                            if (i < formats.length - 1) {
                                continue;
                            }
                            else {
                                return {
                                    format: format,
                                    value: null
                                };
                            }
                        }
                        return {
                            format: format,
                            value: value
                        };
                    }
                }
            }
        }
        catch (caughtNew) {
            if (i < formats.length - 1) {
                continue;
            }
            else {
                handleCaught(caughtNew, options, {
                    reason: 'error-converting-caught-to-json',
                    caughtObjectNestingInfo: nestedCfg,
                    caughtWhenProcessingReportKey: 'as_string'
                });
                return {
                    format: format,
                    value: null
                };
            }
        }
    }
    return {
        format: null,
        value: null
    };
}
function makeProp_as_string_format(format, options, nestedCfg) {
    var res = makeMetadataValue(nestedCfg, options, 'as_string_format', format);
    if ('value' in res) {
        return res.value;
    }
    return undefined;
}
function makeProp_children_sources(options, nestedCfg) {
    var res = makeMetadataValue(nestedCfg, options, 'children_sources', options.childrenSources);
    if ('value' in res) {
        return res.value;
    }
    return undefined;
}
function makeProp_as_json_format(format, options, nestedCfg) {
    var res = makeMetadataValue(nestedCfg, options, 'as_json_format', format);
    if ('value' in res) {
        return res.value;
    }
    return undefined;
}
function makeProp_v(options, nestedCfg) {
    var res = makeMetadataValue(nestedCfg, options, 'v', exports.CORJ_VERSION);
    if ('value' in res) {
        return res.value;
    }
    return undefined;
}
function makeProp_$schema(options, nestedCfg) {
    var res = makeMetadataValue(nestedCfg, options, '$schema', nestedCfg === null
        ? exports.CORJ_REPORT_OBJECT_JSON_SCHEMA_LINK
        : exports.CORJ_REPORT_ARRAY_JSON_SCHEMA_LINK);
    if ('value' in res) {
        return res.value;
    }
    return undefined;
}
function makeProp_as_json(caught, options, nestedCfg) {
    var formats = options.asJsonFormatsToApply;
    for (var i = 0; i < formats.length; ++i) {
        var format = formats[i];
        try {
            switch (format) {
                case exports.CORJ_AS_JSON_FORMAT_TO_CORJ_AS_JSON_METHOD: {
                    var r = safeAccessProp(nestedCfg, 'as_string', options, 'caught', caught, 'toCorjAsJson');
                    if (!('value' in r) || typeof r.value !== 'function') {
                        if (i < formats.length - 1) {
                            continue;
                        }
                        else {
                            return {
                                format: format,
                                value: null
                            };
                        }
                    }
                    else {
                        var stringValue = jsonStringify(r.value.call(caught, { options: options, caught: caught, nestedCfg: nestedCfg }));
                        if (typeof stringValue !== 'string') {
                            if (i < formats.length - 1) {
                                continue;
                            }
                            else {
                                return {
                                    format: format,
                                    value: null
                                };
                            }
                        }
                        else {
                            return {
                                format: format,
                                value: JSON.parse(stringValue)
                            };
                        }
                    }
                }
                case exports.CORJ_AS_JSON_FORMAT_SAFE_STABLE_STRINGIFY_2_4_1: {
                    var jsonString = jsonStringify(caught, function (key, value) {
                        if (this === caught && options.childrenSources.includes(key)) {
                            return undefined;
                        }
                        return value;
                    });
                    if (typeof jsonString !== 'string') {
                        var err = new Error("Could not convert caught object to json string using ".concat(format, "."));
                        err.originalCaught = caught;
                        err.originalCaughtStringifyResult = jsonString;
                        throw err;
                    }
                    return {
                        format: format,
                        value: JSON.parse(jsonString)
                    };
                }
            }
        }
        catch (caughtNew) {
            if (i < formats.length - 1) {
                continue;
            }
            handleCaught(caughtNew, options, {
                reason: 'error-converting-caught-to-json',
                caughtObjectNestingInfo: nestedCfg,
                caughtWhenProcessingReportKey: 'as_json'
            });
            return {
                format: format,
                value: null
            };
        }
    }
    return {
        format: null,
        value: null
    };
}
function makeProp_message(caught, options, nestedCfg) {
    try {
        var safeAccessPropHere = safeAccessProp.bind(null, nestedCfg, 'message', options);
        var r = safeAccessPropHere('caught', caught, 'message');
        if (r.caughtDuring) {
            return null;
        }
        if (!('value' in r) || typeof r.value !== 'string') {
            return undefined;
        }
        return r.value;
    }
    catch (caughtNew) {
        handleCaught(caughtNew, options, {
            reason: 'unknown',
            caughtObjectNestingInfo: nestedCfg,
            caughtWhenProcessingReportKey: 'message'
        });
        return null;
    }
}
function makeProp_stack(caught, options, nestedCfg) {
    try {
        var safeAccessPropHere = safeAccessProp.bind(null, nestedCfg, 'stack', options);
        var r = safeAccessPropHere('caught', caught, 'stack');
        if (r.caughtDuring) {
            return null;
        }
        if (!('value' in r) || typeof r.value !== 'string') {
            return undefined;
        }
        return r.value;
    }
    catch (caughtNew) {
        handleCaught(caughtNew, options, {
            reason: 'unknown',
            caughtObjectNestingInfo: nestedCfg,
            caughtWhenProcessingReportKey: 'stack'
        });
        return null;
    }
}
function makeProp_constructor_name(caught, options, nestedCfg) {
    try {
        var safeAccessPropHere = safeAccessProp.bind(null, nestedCfg, 'constructor_name', options);
        var r = safeAccessPropHere('caught', caught, 'constructor');
        if (r.caughtDuring) {
            return null;
        }
        if (!('value' in r)) {
            return undefined;
        }
        var constructor = r.value;
        var rr = safeAccessPropHere('caught.constructor', constructor, 'name');
        if (rr.caughtDuring) {
            return null;
        }
        if (!('value' in rr) || typeof rr.value !== 'string') {
            return undefined;
        }
        return rr.value;
    }
    catch (caughtNew) {
        handleCaught(caughtNew, options, {
            reason: 'unknown',
            caughtWhenProcessingReportKey: 'constructor_name',
            caughtObjectNestingInfo: nestedCfg
        });
        return null;
    }
}
// ██████╗ ███████╗██████╗  ██████╗ ██████╗ ████████╗    ██████╗ ██╗   ██╗██╗██╗     ██████╗ ███████╗██████╗ ███████╗
// ██╔══██╗██╔════╝██╔══██╗██╔═══██╗██╔══██╗╚══██╔══╝    ██╔══██╗██║   ██║██║██║     ██╔══██╗██╔════╝██╔══██╗██╔════╝
// ██████╔╝█████╗  ██████╔╝██║   ██║██████╔╝   ██║       ██████╔╝██║   ██║██║██║     ██║  ██║█████╗  ██████╔╝███████╗
// ██╔══██╗██╔══╝  ██╔═══╝ ██║   ██║██╔══██╗   ██║       ██╔══██╗██║   ██║██║██║     ██║  ██║██╔══╝  ██╔══██╗╚════██║
// ██║  ██║███████╗██║     ╚██████╔╝██║  ██║   ██║       ██████╔╝╚██████╔╝██║███████╗██████╔╝███████╗██║  ██║███████║
// ╚═╝  ╚═╝╚══════╝╚═╝      ╚═════╝ ╚═╝  ╚═╝   ╚═╝       ╚═════╝  ╚═════╝ ╚═╝╚══════╝╚═════╝ ╚══════╝╚═╝  ╚═╝╚══════╝
function makeChildrenEntries(maker, caught) {
    var root = { index: -1, obj: caught, path: '$', level: 0 };
    var stack = [root];
    var childrenObject = [];
    var index = 0;
    var _loop_2 = function () {
        var cur = stack.pop();
        cur.nestedIds = [];
        var thisLevel = cur.level + 1;
        var nestedObjectsOf = getNestedObjectsOfCaught(cur.obj, maker);
        if (thisLevel > maker.options.maxChildrenLevel) {
            if (nestedObjectsOf.length > 0) {
                cur.omittedReason = exports.CORJ_NESTED_OMITTED_REASONS.REACHED_MAX_DEPTH(maker.options.maxChildrenLevel);
            }
            return "continue";
        }
        var withIds = nestedObjectsOf.map(function (n) {
            return {
                index: index++,
                obj: n.obj,
                path: cur.path + n.path,
                level: thisLevel
            };
        });
        cur.nestedIds = withIds.map(function (n) {
            return maker.options.makeReportId({
                caught: n.obj,
                index: n.index,
                path: n.path,
                level: n.level
            });
        });
        childrenObject.push.apply(childrenObject, withIds);
        stack.push.apply(stack, withIds);
    };
    while (stack.length > 0) {
        _loop_2();
    }
    if (childrenObject.length === 0) {
        return {
            rootIds: root.nestedIds,
            omittedReason: root.omittedReason
        };
    }
    return {
        rootIds: root.nestedIds,
        omittedReason: root.omittedReason,
        flatChildrenEntries: childrenObject
            .map(function (no) {
            var _a = makeParentObjectSelfEntries(maker, no.obj, {
                level: no.level,
                path: no.path,
                index: no.index
            }), mainEntries = _a.mainEntries, metadataEntries = _a.metadataEntries;
            return __spreadArray(__spreadArray(__spreadArray([
                [
                    'id',
                    maker.options.makeReportId({
                        caught: caught,
                        index: no.index,
                        path: no.path,
                        level: no.level
                    }),
                ],
                ['path', no.path],
                ['level', no.level]
            ], mainEntries, true), [
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                ['children', no.nestedIds.length > 0 ? no.nestedIds : undefined],
                ['children_omitted_reason', no.omittedReason]
            ], false), metadataEntries, true).filter(function (_a) {
                var v = _a[1];
                return v !== undefined;
            });
        })
            .filter(function (_a) {
            var v = _a[1];
            return v !== undefined;
        })
    };
}
function makeParentObjectSelfEntries(maker, caught, nestedCfg) {
    var instanceof_error;
    var typeof_prop;
    var constructor_name;
    var message;
    var as_string_format;
    var as_string;
    var as_json_format;
    var as_json;
    var stack;
    var v;
    var $schema;
    var children_sources;
    try {
        // Metadata
        v = makeProp_v(maker.options, nestedCfg);
        $schema = makeProp_$schema(maker.options, nestedCfg);
        children_sources = makeProp_children_sources(maker.options, nestedCfg);
        // Less likely to throw in onCaughtMaking
        instanceof_error = caught instanceof Error;
        typeof_prop = typeof caught;
        constructor_name = makeProp_constructor_name(caught, maker.options, nestedCfg);
        message = makeProp_message(caught, maker.options, nestedCfg);
        stack = makeProp_stack(caught, maker.options, nestedCfg);
        // More likely to throw in onCaughtMaking
        var asString = makeProp_as_string(caught, maker.options, nestedCfg);
        as_string_format = makeProp_as_string_format(asString.format, maker.options, nestedCfg);
        as_string = asString.value;
        var asJson = makeProp_as_json(caught, maker.options, nestedCfg);
        as_json_format = makeProp_as_json_format(asJson.format, maker.options, nestedCfg);
        as_json = asJson.value;
    }
    catch (caughtNew) {
        handleCaught(caughtNew, maker.options, {
            reason: 'unknown',
            caughtObjectNestingInfo: nestedCfg,
            caughtWhenProcessingReportKey: null
        });
    }
    var mainEntries = [
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-expect-error
        ['instanceof_error', instanceof_error],
        ['typeof', typeof_prop],
        ['constructor_name', constructor_name],
        ['message', message],
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-expect-error
        ['as_string', as_string],
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-expect-error
        ['as_json', as_json],
        ['stack', stack],
    ].filter(function (_a) {
        var v = _a[1];
        return v !== undefined;
    });
    var metadataEntries = [
        ['children_sources', children_sources],
        ['as_string_format', as_string_format],
        ['as_json_format', as_json_format],
        ['v', v],
        ['$schema', $schema],
    ].filter(function (_a) {
        var v = _a[1];
        return v !== undefined;
    });
    return {
        mainEntries: mainEntries,
        metadataEntries: metadataEntries
    };
}
// ███████╗██╗  ██╗██████╗  ██████╗ ██████╗ ████████╗███████╗
// ██╔════╝╚██╗██╔╝██╔══██╗██╔═══██╗██╔══██╗╚══██╔══╝██╔════╝
// █████╗   ╚███╔╝ ██████╔╝██║   ██║██████╔╝   ██║   ███████╗
// ██╔══╝   ██╔██╗ ██╔═══╝ ██║   ██║██╔══██╗   ██║   ╚════██║
// ███████╗██╔╝ ██╗██║     ╚██████╔╝██║  ██║   ██║   ███████║
// ╚══════╝╚═╝  ╚═╝╚═╝      ╚═════╝ ╚═╝  ╚═╝   ╚═╝   ╚══════╝
var CorjMaker = /** @class */ (function () {
    function CorjMaker(options) {
        this.options = screenOptionsForAccessorErrors(options);
    }
    /**
     * This exists to produce entries in dependable order.
     */
    CorjMaker.prototype.makeReportObjectEntries = function (caught) {
        var _a = makeParentObjectSelfEntries(this, caught, null), mainEntries = _a.mainEntries, metadataEntries = _a.metadataEntries;
        var _b = makeChildrenEntries(this, caught), omittedReason = _b.omittedReason, flatChildrenEntries = _b.flatChildrenEntries;
        return __spreadArray(__spreadArray(__spreadArray([], mainEntries, true), [
            ['children_omitted_reason', omittedReason],
            [
                'children',
                !Array.isArray(flatChildrenEntries)
                    ? undefined
                    : flatChildrenEntries.map(function (chEntries) {
                        return Object.fromEntries(chEntries);
                    }),
            ]
        ], false), metadataEntries, true).filter(function (_a) {
            var v = _a[1];
            return v !== undefined;
        });
    };
    CorjMaker.prototype.makeReportObject = function (caught) {
        return Object.fromEntries(this.makeReportObjectEntries(caught));
    };
    CorjMaker.prototype.makeReportArrayEntries = function (caught) {
        var effectiveMaker = this.cloneWith({
            childrenMetadataFields: this.options.metadataFields
        });
        var _a = makeParentObjectSelfEntries(effectiveMaker, caught, null), mainEntries = _a.mainEntries, metadataEntries = _a.metadataEntries;
        var rootId = effectiveMaker.options.makeReportId({
            caught: caught,
            index: -1,
            path: '$',
            level: 0
        });
        var _b = makeChildrenEntries(effectiveMaker, caught), rootIds = _b.rootIds, omittedReason = _b.omittedReason, flatChildrenEntries = _b.flatChildrenEntries;
        return __spreadArray([
            __spreadArray(__spreadArray(__spreadArray([
                ['id', rootId],
                ['path', '$'],
                ['level', 0]
            ], mainEntries, true), [
                ['children_omitted_reason', omittedReason],
                ['children', rootIds]
            ], false), metadataEntries, true).filter(function (_a) {
                var _ = _a[0], v = _a[1];
                return v !== undefined;
            })
        ], (!Array.isArray(flatChildrenEntries) ? [] : flatChildrenEntries), true);
    };
    CorjMaker.prototype.makeReportArray = function (caught) {
        var arrayEntries = this.makeReportArrayEntries(caught);
        return arrayEntries.map(function (reportObjectEntries) {
            return Object.fromEntries(reportObjectEntries);
        });
    };
    CorjMaker.withDefaults = function (options) {
        if (options === void 0) { options = exports.CORJ_MAKER_DEFAULT_OPTIONS; }
        var screenedOptions = screenOptionsForAccessorErrors(options);
        var effectiveOptions = mergeOptions(exports.CORJ_MAKER_DEFAULT_OPTIONS, screenedOptions);
        return new CorjMaker(effectiveOptions);
    };
    CorjMaker.prototype.cloneWith = function (options) {
        if (options === void 0) { options = exports.CORJ_MAKER_DEFAULT_OPTIONS; }
        return new CorjMaker(mergeOptions(this.options, options));
    };
    return CorjMaker;
}());
exports.CorjMaker = CorjMaker;
/**
 * Wrapper for {@link CorjMaker#makeReportObjectReportObject | CorjMaker.makeReportObject} with default options specified in {@link CORJ_MAKER_DEFAULT_OPTIONS}.
 */
function makeCaughtObjectReportJson(caught, options) {
    return CorjMaker.withDefaults(options).makeReportObject(caught);
}
exports.makeCaughtObjectReportJson = makeCaughtObjectReportJson;
/**
 * Alias for {@link makeCaughtObjectReportJson}.
 */
exports.bakeCorj = makeCaughtObjectReportJson;
/**
 * Wrapper for {@link CorjMaker#makeReportObjectReportObject | CorjMaker.makeReportArray} with default options specified in {@link CORJ_MAKER_DEFAULT_OPTIONS}.
 */
function makeCaughtObjectReportJsonArray(caught, options) {
    return CorjMaker.withDefaults(options).makeReportArray(caught);
}
exports.makeCaughtObjectReportJsonArray = makeCaughtObjectReportJsonArray;
/**
 * Alias for {@link makeCaughtObjectReportJsonArray}.
 */
exports.bakeCorjArray = makeCaughtObjectReportJsonArray;
